import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/styles';
import { useChartStyles } from './hooks/useChartStyles';

const useStyles = makeStyles((theme) => ({
  div: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  text: {
    color: theme.palette.insights.classificatonLabel,
    ...theme.typography.body2,
    fontSize: theme.spacing(1.5)
  },
  container: {
    height: theme.spacing(12),
    alignContent: 'center',
    marginRight: theme.spacing(2)
  },
  naText: {
    ...theme.typography.body2,
    fontSize: theme.spacing(1.5)
  },
  paper: {
    width: theme.spacing(0.2),
    height: theme.spacing(1.8)
  },
  innerDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '36%'
  }
}));

export const ClassificationBarNoData: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const chartStyle = useChartStyles(theme);
  return (
    <Grid
      container
      data-testid={'note-by-classification-no-data'}
      className={classes.container}
    >
      <Grid item xs={12}>
        <div className={classes.div}>
          <div className={classes.innerDiv}>
            <Typography className={classes.text}>
              <FormattedMessage
                id={'insights.timeClassificationChart.UNCLASSIFIED'}
              />
            </Typography>
            <Paper
              className={classes.paper}
              elevation={0}
              sx={{ backgroundColor: chartStyle.VictoryBar.color.UNCLASSIFIED }}
            ></Paper>
          </div>
          <Typography className={classes.naText}>
            <FormattedMessage id={'insights.timeSheetLabels.na'} />
          </Typography>
        </div>
        <div className={classes.div}>
          <div className={classes.innerDiv}>
            <Typography className={classes.text}>
              <FormattedMessage
                id={'insights.timeClassificationChart.PRIVATE'}
              />
            </Typography>
            <Paper
              className={classes.paper}
              elevation={0}
              sx={{ backgroundColor: chartStyle.VictoryBar.color.PRIVATE }}
            ></Paper>
          </div>
          <Typography className={classes.naText}>
            <FormattedMessage id={'insights.timeSheetLabels.na'} />
          </Typography>
        </div>
        <div className={classes.div}>
          <div className={classes.innerDiv}>
            <Typography className={classes.text}>
              <FormattedMessage
                id={'insights.timeClassificationChart.ACCEPTED'}
              />
            </Typography>
            <Paper
              className={classes.paper}
              elevation={0}
              sx={{ backgroundColor: chartStyle.VictoryBar.color.ACCEPTED }}
            ></Paper>
          </div>
          <Typography className={classes.naText}>
            <FormattedMessage id={'insights.timeSheetLabels.na'} />
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};
